var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-test": "poster" } },
    [
      _c("lazy-image", {
        attrs: { url: _vm.posterSrc, alt: "", color: _vm.coverColor },
        on: { error: _vm.errorPosterLoad }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }